import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333m.613 9.08a.5.5 0 0 0-.06-.12l-.08-.1a.67.67 0 0 0-.726-.14.8.8 0 0 0-.22.14.67.67 0 0 0-.14.727.6.6 0 0 0 .36.36.63.63 0 0 0 .506 0 .6.6 0 0 0 .36-.36.7.7 0 0 0 .054-.253 1 1 0 0 0 0-.134.4.4 0 0 0-.054-.12M7.53 4.862a.667.667 0 0 1 1.138.471V8a.667.667 0 0 1-1.334 0V5.333c0-.177.07-.346.196-.471",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })